// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"ce5fb28b","413":"4e624ba6","455":"2012278e","471":"044f3f88","496":"1b08a742","506":"642277eb","534":"87ce02bd","557":"e027d13d","808":"4d2f6fd5","811":"e7639aed","878":"d80d6e90","885":"bcfa9cc3","958":"685b9610","977":"4380c1a5"}[chunkId] + ".chunk.js";
};